import useApi from '../../hooks/api/useApi';
import useMutate from '../../hooks/api/useMutate';

export function useInitiateSubscription() {
  const { post } = useMutate('/subscription/checkout');
  const initiateSubscription = ({ plan_id, merchant_id, source }) =>
    post({ plan_id, merchant_id, source });
  return { initiateSubscription };
}

export function useSubscriptionStatus(txnid) {
  const { data, error, isLoading, refresh } = useApi(
    txnid ? `/subscription/status?txnid=${txnid}` : null,
    { revalidateOnFocus: false, revalidateOnReconnect: false }
  );

  return {
    payment: data?.data || { status: 'pending', should_poll: true },
    isLoading,
    error,
    refresh
  };
}

export function useCurrentSubscription() {
  const { data, error, isLoading, refresh } = useApi('/subscription/current', {
    revalidateOnFocus: false
  });

  return {
    subscription: data?.data || null,
    isLoading,
    error,
    refresh
  };
}
